import { adminConstants } from "../constant/admin-constant";

const initialState = { loading: false, users: {}, editUser: {} };
export function userReducer(state = initialState, action) {
    switch (action.type) {
        case adminConstants.PAGINATION_USERS_REQUEST:
            return {
                ...state,
                loading: true,
                users: {},
                editUser: "",
                storedUser: "",
                updatedUser: "",
                deleteUser: false
            };
        case adminConstants.PAGINATION_USERS_SUCCESS:
            return {
                ...state,
                usersData: action.payload.users.data,
                pages: action.payload.users.last_page,
                loading: false,
                current_page: action.payload.users.current_page
            };
        case adminConstants.PAGINATION_ADMIN_USERS_SUCCESS:
            return {
                ...state,
                usersData: action.payload.users.data,
                pages: action.payload.users.last_page,
                loading: false,
                current_page: action.payload.users.current_page
            };
        case adminConstants.PAGINATION_USERS_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.STORE_USER_REQUEST:
            return { ...state, loading: true, storedUser: "" };
        case adminConstants.STORE_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                storedUser: action.payload.user
            };
        case adminConstants.STORE_USER_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.GET_USER_REQUEST:
            return { ...state, loading: true };
        case adminConstants.GET_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                editUser: action.payload.result.data
            };
        case adminConstants.GET_USER_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.EDIT_USER_REQUEST:
            return { ...state, loading: true, updatedUser: "" };
        case adminConstants.EDIT_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                updatedUser: action.payload.user
            };
        case adminConstants.EDIT_USER_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.DELETE_USER_REQUEST:
            return { ...state, loading: true, deleteUser: false };
        case adminConstants.DELETE_USER_SUCCESS:
            return { ...state, loading: false, deleteUser: true };
        case adminConstants.DELETE_USER_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.GET_USERS_ORDER_REQUEST:
            return { ...state, loading: true };
        case adminConstants.GET_USERS_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                orderUsers: action.payload.users
            };
        case adminConstants.GET_USERS_ORDER_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.CHANGE_USER_PASSWORD_REQUEST:
            return { ...state, loading: true, newUserData: "" };
        case adminConstants.CHANGE_USER_PASSWORD_SUCCESS:
            return {
                ...state,
                loading: false,
                newUserData: action.payload.user
            };
        case adminConstants.CHANGE_USER_PASSWORD_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.SIGNUP_CUSTOMER_REQUEST:
            return { ...state, loading: true, };
        case adminConstants.SIGNUP_CUSTOMER_SUCCESS:
            return {
                ...state,
                loading: false,
                newCustomer: action.payload.result.user
            };
        case adminConstants.SIGNUP_CUSTOMER_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.SEND_RECOVERY_EMAIL_REQUEST:
            return { ...state, loading: true, };
        case adminConstants.SEND_RECOVERY_EMAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                reoverEmailData: action.payload
            };
        case adminConstants.SEND_RECOVERY_EMAIL_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.RESET_USER_PASSWORD_REQUEST:
            return { ...state, loading: true, };
        case adminConstants.RESET_USER_PASSWORD_SUCCESS:
            return {
                ...state,
                loading: false,
                resettedPassword: action.payload
            };
        case adminConstants.RESET_USER_PASSWORD_FAILURE:
            return { ...state, loading: false, error: action.payload };


        case adminConstants.GET_USER_PROFILE_REQUEST:
            return { ...state, loading: true };
        case adminConstants.GET_USER_PROFILE_SUCCESS:
            return {
                ...state,
                loading: false,
                user_profile: action.payload.result.user_profile
            };
        case adminConstants.GET_USER_PROFILE_FAILURE:
            return { ...state, loading: false, error: action.payload };

        default:
            return { ...state };
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/UserReducer.jsx